import { render, staticRenderFns } from "./OwnersListTableBodyRow.vue?vue&type=template&id=b92288b8&scoped=true&"
import script from "./OwnersListTableBodyRow.vue?vue&type=script&lang=js&"
export * from "./OwnersListTableBodyRow.vue?vue&type=script&lang=js&"
import style0 from "./OwnersListTableBodyRow.vue?vue&type=style&index=0&id=b92288b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92288b8",
  null
  
)

export default component.exports